import abl from './abl';
import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import scheduleReducer from './reducers/index';
import clients from './clients/clients';
import App from './containers/app_container';
import ScheduleViewer from './containers/schedule_viewer_container';
import ScheduleHeader from './containers/schedule_header_container';
import ScheduleInspector from './containers/schedule_inspector_container';

const Router = Backbone.Router.extend({

  routes: {
    '': 'index',
    'school/:school/schedules/:term(/:scheduleId)': 'schedule',
    '*404': '404'
  },

  initialize: function() {
    
  },

  index: function() {
    var defaultUrl = abl.config.defaultUrl;
    if(defaultUrl) {
      this.navigate(defaultUrl, {
        trigger: true,
        replace: true
      });
    }
  },

  404: function() {
    console.log('404 page')
  },

  schedule: function(school, term, scheduleId) {
    let store = createStore(
      scheduleReducer,
      {},
      compose(
        applyMiddleware(
          thunkMiddleware.withExtraArgument(clients)
        ),
        abl.config.reduxDevTools ? abl.config.reduxDevTools() : f => f
      )
    );
    
    let data = {
      school: school,
      term: term,
      scheduleId: scheduleId
    }

    ReactDOM.render((
      <Provider store={store}>
        <App data={data}>
           <div className="abl-schedule-app">
            <ScheduleHeader data={data}/>
            <ScheduleInspector data={data} />
            <ScheduleViewer data={data} />
          </div>
        </App>
      </Provider>
    ), document.getElementsByClassName('abl-bdy')[0]);
  }
});

export default Router;


/** WEBPACK FOOTER **
 ** ./src/js/router.js
 **/